import Head from 'next/head';
import styles from './../index.module.css'
export default function RabattkodeNytese() {
	return (
		<>
		<Head>
        	<title>Billigesexleker.no | Nytelse Rabattkode</title>
			<meta name="description" content="Vi har egen rabattkode som kan brukes hos Nytelse, som gir 15% rabatt for alle kjøpt over 500 kroner." />
			<meta name="og:title" content="Billigesexleker.no | Nytelse Rabattkode"></meta>
			<meta name="og:description" content="Vi har egen rabattkode som kan brukes hos Nytelse, som gir 15% rabatt for alle kjøpt over 500 kroner."></meta>        
		</Head>
		<main style={{fontSize: '.9em', padding: '8px'}}>
			<h1>Nytelse Rabattkode</h1>
			<article style={{fontWeight: 600}}>
				Nytelse.no er en norsk nettbutikk som har eksistert siden 2005, og har et stort utvalg av sexleketøy, undertøy, glidemiddel og andre erotiske produkter.
				I tillegg til gode priser, kampanjer og stort et utvalgt, tilbyr de lynrask levering fra eget lager i Holmestrand og diskret pakking.
				Vi i billigesexleker.no er stolte å kunne tilby våre brukere en egen rabattkode som gir 15% rabatt på alle kjøp over 500 kroner.
				Dette er en rabattkupong eksklusiv for billigesexleker.no sine besøkende, og kan ikke kombineres med andre tilbud.
			</article>
			<br/>
			<section className={styles.indexArticle} style={{fontWeight: 600, textAlign: 'center'}}>
				<a href="https://www.nytelse.no/tt/?tt=12509_12_263403_rabattkodebsl25&r=%2F" target="_blank" rel="nofollow noopener">
					Klikk her og benytt rabattkode BSL25 i kassen for å få rabatten
				</a>
			</section>
			<p style={{fontSize: '.8em'}}>
				Koden er gyldig til og med 31.12.2024. (Varemerket Womanizer er unntatt rabattkoder pga. avtale med leverandør.)<br/>
				Oppdatert januar 2024.
			</p>
		</main>
		</>
	);
}